var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: "Categoría",
                      "prepend-icon": "mdi-animation-outline",
                      "no-data-text": "No hay categorías disponibles",
                      items: _vm.formValues.categoriesTypings,
                      "return-object": "",
                      "item-text": "name",
                      rules: [_vm.rules.required()]
                    },
                    on: {
                      change: function() {
                        _vm.formValues.generalInformation.subCategory = null
                      }
                    },
                    model: {
                      value: _vm.formValues.generalInformation.category,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formValues.generalInformation,
                          "category",
                          $$v
                        )
                      },
                      expression: "formValues.generalInformation.category"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: "Sub-categoría",
                      "prepend-icon": "mdi-animation-outline",
                      "no-data-text": "No hay subcategorías disponibles",
                      disabled: !_vm.formValues.generalInformation.category,
                      items: _vm.formValues.generalInformation.category
                        ? _vm.formValues.generalInformation.category
                            .subCategoriesTypings
                        : [],
                      "return-object": "",
                      "item-text": "name",
                      rules: [_vm.rules.required()]
                    },
                    on: {
                      change: function() {
                        return (_vm.formValues.generalInformation.subject = null)
                      }
                    },
                    model: {
                      value: _vm.formValues.generalInformation.subCategory,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formValues.generalInformation,
                          "subCategory",
                          $$v
                        )
                      },
                      expression: "formValues.generalInformation.subCategory"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: "Asunto",
                      "prepend-icon": "mdi-account-question",
                      "no-data-text": "No hay asuntos disponibles",
                      disabled: !_vm.formValues.generalInformation.subCategory,
                      items: _vm.formValues.generalInformation.subCategory
                        ? _vm.formValues.generalInformation.subCategory
                            .subjectTypings
                        : [],
                      "item-text": "name",
                      rules: [_vm.rules.required()],
                      "return-object": ""
                    },
                    model: {
                      value: _vm.formValues.generalInformation.subject,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formValues.generalInformation,
                          "subject",
                          $$v
                        )
                      },
                      expression: "formValues.generalInformation.subject"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "mr-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nombre",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(50),
                                _vm.rules.specialCharacters(),
                                _vm.rules.allowLettersExclusively()
                              ],
                              disabled: "",
                              "prepend-icon": "mdi-account"
                            },
                            model: {
                              value:
                                _vm.formValues.generalInformation.firstName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formValues.generalInformation,
                                  "firstName",
                                  $$v
                                )
                              },
                              expression:
                                "formValues.generalInformation.firstName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Apellido",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.fieldLength(50),
                                _vm.rules.specialCharacters(),
                                _vm.rules.allowLettersExclusively()
                              ],
                              disabled: "",
                              "prepend-icon": "mdi-account"
                            },
                            model: {
                              value: _vm.formValues.generalInformation.lastName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formValues.generalInformation,
                                  "lastName",
                                  $$v
                                )
                              },
                              expression:
                                "formValues.generalInformation.lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mr-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "########",
                                expression: "'########'"
                              }
                            ],
                            attrs: {
                              label: "Cédula de Identidad",
                              rules: [
                                _vm.rules.required(),
                                _vm.rules.specialCharacters()
                              ],
                              disabled: "",
                              "prepend-icon": "mdi-card-account-details"
                            },
                            model: {
                              value: _vm.formValues.generalInformation.idNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formValues.generalInformation,
                                  "idNumber",
                                  $$v
                                )
                              },
                              expression:
                                "formValues.generalInformation.idNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("phone-field", {
                            attrs: {
                              label: "Teléfono",
                              "phone-data":
                                _vm.formValues.generalInformation
                                  .telephoneNumber,
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "end" } },
            [
              _c(
                "v-col",
                [
                  _c("v-textarea", {
                    attrs: {
                      counter: "65500",
                      outlined: "",
                      label: "Descripción del ticket",
                      hint:
                        "Descripción sobre el ticket de Gestión y Servicios Administrados",
                      rules: [
                        _vm.rules.required(),
                        _vm.rules.fieldLength(65500),
                        _vm.rules.specialCharacters([",", "."])
                      ]
                    },
                    model: {
                      value: _vm.formValues.generalInformation.description,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formValues.generalInformation,
                          "description",
                          $$v
                        )
                      },
                      expression: "formValues.generalInformation.description"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("form-navigation-buttons", {
        attrs: { "first-step": "true" },
        on: {
          validateStep: _vm.validateStep,
          reset: function($event) {
            return _vm.$router.push({ name: "tickets" })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }